import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_BANK_REQUEST = 'preset/GET_BANK_REQUEST'
const GET_BANK_SUCCESS = 'preset/GET_BANK_SUCCESS'
const GET_BANK_FAILURE = 'preset/GET_BANK_FAILURE'

const CREATE_BANK_REQUEST = 'preset/CREATE_BANK_REQUEST'
const CREATE_BANK_SUCCESS = 'preset/CREATE_BANK_SUCCESS'
const CREATE_BANK_FAILURE = 'preset/CREATE_BANK_FAILURE'

const UPDATE_BANK_REQUEST = 'preset/UPDATE_BANK_REQUEST'
const UPDATE_BANK_SUCCESS = 'preset/UPDATE_BANK_SUCCESS'
const UPDATE_BANK_FAILURE = 'preset/UPDATE_BANK_FAILURE'

const DELETE_BANK_REQUEST = 'preset/DELETE_BANK_REQUEST'
const DELETE_BANK_SUCCESS = 'preset/DELETE_BANK_SUCCESS'
const DELETE_BANK_FAILURE = 'preset/DELETE_BANK_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  bank: [],
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BANK_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_BANK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        bank: action.payload
      }
    case GET_BANK_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_BANK_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_BANK_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_BANK_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BANK_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BANK_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BANK_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BANK_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BANK_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BANK_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }

}

// Action Creators
export const getBank = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_BANK_REQUEST
      })

      const response = await API.get(EndPoints.BANK + `/bankAccount/all`)
      dispatch({
        type: GET_BANK_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_BANK_FAILURE
      })
    }
  }
}
export const createBank = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BANK_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.BANK + `/bankAccount/createBankAccount`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_BANK_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_BANK_FAILURE
      })
    }
  }
}
export const updateBank = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BANK_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.BANK + `/bankAccount/updateBankAccount`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_BANK_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BANK_FAILURE
      })
    }
  }
}
export const deleteBank = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BANK_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.BANK + `/bankAccount`+ `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_BANK_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BANK_FAILURE
      })
    }
  }
}

